import axios from "axios";
import Swal from "sweetalert2";
import { baseUrl, errorTranslate } from "./util";
import i18n from "../i18n";
export const getInventoriesPromise = async ({ id }) => {
  var config = {
    method: "get",
    url: baseUrl + "/api/business/" + id + "/supplies/list",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  const { data: response } = await axios.get(config.url, {
    headers: config.headers,
  });

  if (response.data.length > 0) {
    return response.data;
  } else return [];
};

export const getInventoriesDropdown = async ({ setDropdown }) => {
  var config = {
    method: "get",
    url: baseUrl + "/api/business/all?field=supplies",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setDropdown(
        response.data.data.map((supply) => {
          supply.value = supply.name;
          return supply;
        })
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getLocationDropdown = ({ setDropdown }) => {
  var config = {
    method: "get",
    url: baseUrl + "/api/business/list",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  };

  axios(config)
    .then(function (response) {
      setDropdown(
        response.data.data.map((size) => {
          size.value = size.name;
          return size;
        })
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getProductDropdown = ({ setDropdown }) => {
  var config = {
    method: "get",
    url: baseUrl + "/api/business/product/list",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  };

  axios(config)
    .then(function (response) {
      setDropdown(
        response.data.data.map((size) => {
          size.value = size.name;
          return size;
        })
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getRoles = ({ setDropdown }) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/accounts/roles",
    headers: {},
  };

  axios(config)
    .then(function (response) {
      // console.log(response.data.data);
      setDropdown(
        response.data.data.map((size) => {
          size.value = size.name;
          return size;
        })
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getMeansOfTransport = ({ setDropdown }) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/transport",
    headers: {},
  };

  const getLanguage = () => i18n.language;
  const hiotName =
    getLanguage() === "en" ? "product_type_name_en" : "product_type_name";
  axios(config)
    .then(function (response) {
      // console.log(response.data.data);
      setDropdown(
        response.data.data
          .map((size) => {
            size.value = size[hiotName];
            size.name = size[hiotName];
            return size;
          })
          .sort(compare)
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getTravelCommuteData = ({
  setDropdown = function () {
    return;
  },
}) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/travel-commute-data",
    headers: {},
  };

  const getLanguage = () => i18n.language;
  const hiotName =
    getLanguage() === "en" ? "dropdown_name_en" : "dropdown_name";
  axios(config)
    .then(function (response) {
      // console.log(response.data.data);
      setDropdown(
        response.data.data
          .map((size) => {
            size.value = size[hiotName];
            size.name = size[hiotName];
            return size;
          })
          .sort(compare)
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getCountryHotel = ({ setDropdown }) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/hiot-hotel",
    headers: {},
  };

  axios(config)
    .then(function (response) {
      const getLanguage = () => i18n.language;
      const hiotName =
        getLanguage() === "en" ? "country_code_en" : "country_code";
      setDropdown(
        response.data.data
          .map((size) => {
            size.value = size[hiotName];
            size.name = size[hiotName];
            return size;
          })
          .sort(compare)
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getHotelData = ({ setDropdown }) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/travel-hotel-data",
    headers: {},
  };

  axios(config)
    .then(function (response) {
      const getLanguage = () => i18n.language;
      const hiotName =
        getLanguage() === "en"
          ? "visiting_country_name_en"
          : "visiting_country_name";
      setDropdown(
        response.data.data
          .map((size) => {
            size.value = size[hiotName];
            size.name = size[hiotName];
            return size;
          })
          .sort(compare)
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getWasteMethod = ({ setDropdown }) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/hiot-waste",
    headers: {},
  };

  axios(config)
    .then(function (response) {
      // console.log(response.data.data);
      setDropdown(
        response.data.data
          .map((size) => {
            size.value = size.product_type_name;
            size.name = size.product_type_name;
            return size;
          })
          .sort(compare)
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getGasRefrigerant = ({
  setDropdown = function () {
    return;
  },
}) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/refrigerant",
    headers: {},
  };

  axios(config)
    .then(function (response) {
      // console.log(response.data.data);
      const getLanguage = () => i18n.language;
      const hiotName =
        getLanguage() === "en" ? "dropdown_name_en" : "dropdown_name";
      setDropdown(
        response.data.data
          .map((size) => {
            size.value = size[hiotName];
            size.name = size[hiotName];

            return size;
          })
          .sort(compare)
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getSuppresantIndustrialData = ({
  setDropdown = function () {
    return;
  },
}) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/suppressant-industrial-data",
    headers: {},
  };

  axios(config)
    .then(function (response) {
      const getLanguage = () => i18n.language;
      const hiotName = getLanguage() === "en" ? "name_en" : "name";
      setDropdown(
        response.data.data
          .map((size) => {
            size.value = size[hiotName];
            size.name = size[hiotName];

            return size;
          })
          .sort(compare)
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getHeatingSource = ({ businessSizeList, setBusinessSizeList }) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/fuel",
    headers: {},
  };

  axios(config)
    .then(function (response) {
      // console.log(response.data.data);
      setBusinessSizeList(
        response.data.data
          .map((size) => {
            size.value = size.name;
            // if (!size.value.includes("("))
            size.value = size.name + " " + size.physical_unit + "";
            // else {
            //   size.value = size.name.replace(/\((.+?)\)/g, "("+size.physical_unit+")")
            // }
            return size;
          })
          .sort(compare)
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getExternalPowerSource = ({
  businessSizeList,
  setBusinessSizeList,
}) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/external-power-source",
    headers: {},
  };

  axios(config)
    .then(function (response) {
      // console.log(response.data.data);
      const getLanguage = () => i18n.language;
      const hiotName =
        getLanguage() === "en" ? "product_type_name_en" : "product_type_name";
      setBusinessSizeList(
        response.data.data
          .map((size) => {
            size.value = size[hiotName];
            size.name = size[hiotName];
            // if (!size.value.includes("("))
            size.value = size[hiotName] + " " + size.physical_unit + "";
            // else {
            //   size.value = size.name.replace(/\((.+?)\)/g, "("+size.physical_unit+")")
            // }
            return size;
          })
          .sort(compare)
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getWaterSourceData = ({
  dropdownWaterData,
  setDropdownWaterData = function () {
    return;
  },
}) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/water-source-data",
    headers: {},
  };

  axios(config)
    .then(function (response) {
      const getLanguage = () => i18n.language;
      const hiotName =
        getLanguage() === "en" ? "material_name_en" : "material_name";
      setDropdownWaterData(
        response.data.data
          .map((water) => {
            water.value = water[hiotName];
            water.name = water[hiotName];
            return water;
          })
          .sort(compare)
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getInventoryMaterialData = ({
  dropdownData,
  setDropdownData = function () {
    return;
  },
}) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/inventory-material-data",
    headers: {},
  };

  axios(config)
    .then(function (response) {
      // console.log(response.data.data);
      const getLanguage = () => i18n.language;
      const hiotName = getLanguage() === "en" ? "material_en" : "material";
      setDropdownData(
        response.data.data
          .map((material) => {
            material.value = material[hiotName];
            material.name = material[hiotName];

            return material;
          })
          .sort(compare)
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getInventoryPackagingData = ({
  dropdownData,
  setDropdownData = function () {
    return;
  },
}) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/inventory-packaging-data",
    headers: {},
  };

  axios(config)
    .then(function (response) {
      // console.log(response.data.data);
      const getLanguage = () => i18n.language;
      const hiotName = getLanguage() === "en" ? "packaging_en" : "packaging";
      setDropdownData(
        response.data.data
          .map((packaging) => {
            packaging.value = packaging[hiotName];
            packaging.name = packaging[hiotName];

            return packaging;
          })
          .sort(compare)
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getInventoryMachineData = ({ dropdownData, setDropdownData }) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/inventory-machine-data",
    headers: {},
  };

  axios(config)
    .then(function (response) {
      // console.log(response.data.data);
      const getLanguage = () => i18n.language;
      const hiotName =
        getLanguage() === "en" ? "dropdown_name_en" : "dropdown_name";
      setDropdownData(
        response.data.data
          .map((machine) => {
            machine.value = machine[hiotName];
            machine.name = machine[hiotName];

            return machine;
          })
          .sort(compare)
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getInventoryBuildingData = ({ dropdownData, setDropdownData }) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/inventory-building-data",
    headers: {},
  };

  axios(config)
    .then(function (response) {
      // console.log(response.data.data);
      const getLanguage = () => i18n.language;
      const hiotName =
        getLanguage() === "en" ? "dropdown_name_en" : "dropdown_name";
      setDropdownData(
        response.data.data
          .map((building) => {
            building.value = building[hiotName];
            building.name = building[hiotName];

            return building;
          })
          .sort(compare)
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getInventoryServiceData = ({ dropdownData, setDropdownData }) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/inventory-service-data",
    headers: {},
  };

  axios(config)
    .then(function (response) {
      // console.log(response.data.data);
      const getLanguage = () => i18n.language;
      const hiotName =
        getLanguage() === "en" ? "dropdown_name_en" : "dropdown_name";
      setDropdownData(
        response.data.data
          .map((service) => {
            service.value = service[hiotName];
            service.name = service[hiotName];

            return service;
          })
          .sort(compare)
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

function compare(a, b) {
  if (a.value < b.value) {
    return -1;
  }
  if (a.value > b.value) {
    return 1;
  }
  return 0;
}

export const getHiotCategory = ({
  businessSizeList,
  setBusinessSizeList,
  country,
}) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/hiot/" + country,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  };

  const getLanguage = () => i18n.language;
  const hiotName =
    getLanguage() === "en" ? "product_type_name_en" : "product_type_name";

  axios(config)
    .then(function (response) {
      // console.log(response.data.data.map((size)=>{
      //       size.value = size.product_type_name
      //       return size
      //   }).sort(compare));
      if (response.data.data.length > 0) {
        setBusinessSizeList((data) =>
          response.data.data
            .map((size) => {
              // console.log(size)
              size.value = size[hiotName];
              return size;
            })
            .sort(compare)
        );
      } else {
        setBusinessSizeList([{ id: "abcd", value: "-", name: "-" }]);
      }
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getMaterial = ({ businessSizeList, setBusinessSizeList }) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/material",
    headers: {},
  };

  axios(config)
    .then(function (response) {
      // console.log("material data", response.data.data);
      setBusinessSizeList(
        response.data.data.map((size) => {
          // console.log(size)
          size.value = size.name;
          return size;
        })
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const searchVehicle = ({ query, setDropdown, loading, setLoading }) => {
  const config = {
    method: "get",
    url:
      baseUrl + "/api/business/vehicle/search?name=" + (!query ? "a" : query),
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  };
  if (loading) {
    setLoading("load");
  }
  axios(config)
    .then(function (response) {
      if (loading) setLoading("success");
      if (response.data.data.results.length > 0)
        setDropdown(
          response.data.data.results.map((result, i) => {
            return {
              value: result["Cn"] + ", " + result["Mk"] + ", " + result["Year"],
              id: i,
              emission: result["Ewltp (g/km)"],
            };
          })
        );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getWasteMaterial = async ({
  setDropdown = function () {
    return;
  },
  setDisposalDropdown = function () {
    return;
  },
}) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/waste-material",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      const getLanguage = () => i18n.language;
      const hiotName =
        getLanguage() === "en" ? "surplus_material_en" : "surplus_material";
      const disposalName =
        getLanguage() === "en" ? "current_disposal_en" : "current_disposal";

      const uniqueSupplies = new Set(
        response.data.data.map((supply) => supply[hiotName])
      );
      const uniqueDisposals = new Set(
        response.data.data.map((supply) => supply[disposalName])
      );

      setDropdown(
        [...uniqueSupplies].map((supply) => {
          const matchingSupply = response.data.data.find(
            (item) => item[hiotName] === supply
          );
          return {
            value: supply,
            name: supply,
            ...matchingSupply,
          };
        })
      );

      setDisposalDropdown(
        [...uniqueDisposals].map((disposal) => {
          const matchingDisposal = response.data.data.find(
            (item) => item[disposalName] === disposal
          );
          return {
            value: disposal,
            name: disposal,
            ...matchingDisposal,
          };
        })
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getWasteDisposalMethod = async ({ setDisposalDropdown }) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/waste-disposal-method",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      const getLanguage = () => i18n.language;
      const disposalName =
        getLanguage() === "en" ? "current_disposal_en" : "current_disposal";

      const uniqueDisposals = new Set(
        response.data.data.map((supply) => supply[disposalName])
      );

      setDisposalDropdown(
        [...uniqueDisposals].map((disposal) => {
          const matchingDisposal = response.data.data.find(
            (item) => item[disposalName] === disposal
          );
          return {
            value: disposal,
            name: disposal,
            ...matchingDisposal,
          };
        })
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getOtherVehicleData = ({ dropdownData, setDropdownData }) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/stationary-combustion-data",
    headers: {},
  };

  axios(config)
    .then(function (response) {
      const getLanguage = () => i18n.language;
      const hiotName =
        getLanguage() === "en" ? "dropdown_name_en" : "dropdown_name";
      setDropdownData(
        response.data.data
          .map((otherVehicle) => {
            otherVehicle.value = otherVehicle[hiotName];
            otherVehicle.name = otherVehicle[hiotName];
            return otherVehicle;
          })
          .sort(compare)
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getTransportDeliveriesData = ({
  dropdownData,
  setDropdownData = function () {
    return;
  },
}) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/transport-deliveries-data",
    headers: {},
  };

  axios(config)
    .then(function (response) {
      const getLanguage = () => i18n.language;
      const hiotName =
        getLanguage() === "en" ? "dropdown_name_en" : "dropdown_name";
      setDropdownData(
        response.data.data
          .map((transport) => {
            transport.value = transport[hiotName];
            transport.name = transport[hiotName];

            return transport;
          })
          .sort(compare)
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getTransportCountryData = ({ dropdownData, setDropdownData }) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/country-transport-data",
    headers: {},
  };

  axios(config)
    .then(function (response) {
      const getLanguage = () => i18n.language;
      const hiotName = getLanguage() === "en" ? "country_en" : "country";
      setDropdownData(
        response.data.data
          .map((transport) => {
            transport.value = transport[hiotName];
            transport.name = transport[hiotName];

            return transport;
          })
          .sort(compare)
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getTransportFuelTypeData = ({ dropdownData, setDropdownData }) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/fuel-transport-data",
    headers: {},
  };

  axios(config)
    .then(function (response) {
      const getLanguage = () => i18n.language;
      const hiotName =
        getLanguage() === "en" ? "dropdown_name_en" : "dropdown_name";
      setDropdownData(
        response.data.data
          .map((transport) => {
            transport.value = transport[hiotName];
            transport.name = transport[hiotName];

            return transport;
          })
          .sort(compare)
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getInventoryProductDropdown = ({
  inventoryDropdown,
  setInventoryDropdown = function () {
    return;
  },
  setInventoryNicknames = function () {
    return;
  },
  setInventoryQty = function () {
    return;
  },
  materialList = null,
}) => {
  const urlParams = new URLSearchParams(window.location.search);
  const year = urlParams.get("year");
  const business = urlParams.get("business");
  const config = {
    method: "get",
    url: baseUrl + "/api/business/inventory-product-dropdown",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    params: {
      year: year,
      business: business,
    },
  };

  axios(config)
    .then(function (response) {
      const dropdownOptions = [];
      const uniqueValues = new Set();
      const removedValues = [];

      for (const [key, values] of Object.entries(response.data.data)) {
        if (materialList === null || materialList.includes(key)) {
          if (Array.isArray(values)) {
            values.forEach((value) => {
              if (!uniqueValues.has(value)) {
                uniqueValues.add(value);
                dropdownOptions.push({ value, label: value });
              } else {
                removedValues.push(value);
              }
            });
          }
        }
      }

      setInventoryDropdown(dropdownOptions);

      const dropdownNicknames = [];
      const uniqueNicknameValues = {};

      for (const [material, nicknamesObj] of Object.entries(
        response.data.nicknames
      )) {
        if (materialList === null || materialList.includes(material)) {
          if (typeof nicknamesObj !== "object" || Array.isArray(nicknamesObj)) {
            continue;
          }

          for (const [key, value] of Object.entries(nicknamesObj)) {
            if (Array.isArray(value)) {
              if (!uniqueNicknameValues[key]) {
                uniqueNicknameValues[key] = [];
              }
              uniqueNicknameValues[key].push(...value);
            }
          }
        }
      }

      for (const [label, values] of Object.entries(uniqueNicknameValues)) {
        dropdownNicknames.push({ label, value: [...new Set(values)] });
      }

      setInventoryNicknames(dropdownNicknames);

      const dropdownQty = [];
      const uniqueQtyValues = {};

      for (const [material, qtyObj] of Object.entries(response.data.qty)) {
        if (materialList === null || materialList.includes(material)) {
          if (typeof qtyObj !== "object" || Array.isArray(qtyObj)) {
            continue;
          }

          for (const [key, value] of Object.entries(qtyObj)) {
            if (Array.isArray(value)) {
              if (!uniqueQtyValues[key]) {
                uniqueQtyValues[key] = [];
              }
              uniqueQtyValues[key].push(...value);
            }
          }
        }
      }

      for (const [label, values] of Object.entries(uniqueQtyValues)) {
        const labelValues = label.split(" & ");
        const labelMaterial = labelValues[0];
        const labelNickname = labelValues[1];
        const [value] = values;
        dropdownQty.push({ labelMaterial, labelNickname, values: value });
      }
      setInventoryQty(dropdownQty);
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getWaterProductDropdown = ({
  productDropdown,
  setProductDropdown = function () {
    return;
  },
  setWasteWaterDropdown = function () {
    return;
  },
  setNicknameDropdown = function () {
    return;
  },
}) => {
  const urlParams = new URLSearchParams(window.location.search);
  const year = urlParams.get("year");
  const business = urlParams.get("business");
  const config = {
    method: "get",
    url: baseUrl + "/api/business/product-water-dropdown",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    params: {
      year: year,
      business: business,
    },
  };

  axios(config)
    .then(function (response) {
      const dropdownOptions = [];
      const uniqueValues = new Set();
      const removedValues = [];
      const dropdownWaste = [];

      for (const [key, values] of Object.entries(response.data.data)) {
        if (Array.isArray(values)) {
          values.forEach((value) => {
            if (!uniqueValues.has(value)) {
              uniqueValues.add(value);
              dropdownOptions.push({ value, label: value });
              if (value === "Spildevand (kg)" || value === "Waste water (kg)") {
                dropdownWaste.push({ value, label: value });
              }
            } else {
              removedValues.push(value);
            }
          });
        }
      }

      setProductDropdown(dropdownOptions);
      setWasteWaterDropdown(dropdownWaste);

      const dropdownNicknames = [];
      const uniqueNicknameValues = {};

      for (const [material, nicknamesObj] of Object.entries(
        response.data.nicknames
      )) {
        if (typeof nicknamesObj !== "object" || Array.isArray(nicknamesObj)) {
          continue;
        }

        for (const [key, value] of Object.entries(nicknamesObj)) {
          if (Array.isArray(value)) {
            if (!uniqueNicknameValues[key]) {
              uniqueNicknameValues[key] = [];
            }
            uniqueNicknameValues[key].push(...value);
          }
        }
      }

      for (const [label, values] of Object.entries(uniqueNicknameValues)) {
        dropdownNicknames.push({ label, value: [...new Set(values)] });
      }

      setNicknameDropdown(dropdownNicknames);
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getWaterCompanyDropdown = ({
  productDropdown,
  id,
  setProductDropdown = function () {
    return;
  },
  setSymbioticDropdown = function () {
    return;
  },
  setNicknameDropdown = function () {
    return;
  },
  setSymbioticNicknameDropdown = function () {
    return;
  },
}) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/water-company-dropdown",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    params: {
      id: id,
    },
  };

  axios(config)
    .then(function (response) {
      const dropdownNicknames = [];
      const uniqueNicknameValues = {};

      for (const [material, nicknamesObj] of Object.entries(
        response.data.nicknames
      )) {
        if (typeof nicknamesObj !== "object" || Array.isArray(nicknamesObj)) {
          continue;
        }

        for (const [key, value] of Object.entries(nicknamesObj)) {
          if (Array.isArray(value)) {
            if (!uniqueNicknameValues[key]) {
              uniqueNicknameValues[key] = [];
            }
            uniqueNicknameValues[key].push(...value);
          }
        }
      }

      for (const [label, values] of Object.entries(uniqueNicknameValues)) {
        dropdownNicknames.push({ label, value: [...new Set(values)] });
      }

      setNicknameDropdown(dropdownNicknames);

      const symbioticDropdownNicknames = [];
      const symbioticUniqueNicknameValues = {};

      for (const [material, nicknamesObj] of Object.entries(
        response.data.symbiotic_nicknames
      )) {
        if (typeof nicknamesObj !== "object" || Array.isArray(nicknamesObj)) {
          continue;
        }

        for (const [key, value] of Object.entries(nicknamesObj)) {
          if (Array.isArray(value)) {
            if (!symbioticUniqueNicknameValues[key]) {
              symbioticUniqueNicknameValues[key] = [];
            }
            symbioticUniqueNicknameValues[key].push(...value);
          }
        }
      }

      for (const [label, values] of Object.entries(
        symbioticUniqueNicknameValues
      )) {
        symbioticDropdownNicknames.push({ label, value: [...new Set(values)] });
      }
      setSymbioticNicknameDropdown(symbioticDropdownNicknames);
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getSurplusProductDropdown = ({
  surplusDropdown,
  setSurplusDropdown = function () {
    return;
  },
  setSurplusNicknames = function () {
    return;
  },
}) => {
  const urlParams = new URLSearchParams(window.location.search);
  const year = urlParams.get("year");
  const business = urlParams.get("business");
  const config = {
    method: "get",
    url: baseUrl + "/api/business/product-surplus-dropdown",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    params: {
      year: year,
      business: business,
    },
  };

  axios(config)
    .then(function (response) {
      const dropdownOptions = [];
      const uniqueValues = new Set();
      const removedValues = [];

      for (const [key, values] of Object.entries(response.data.data)) {
        if (Array.isArray(values)) {
          values.forEach((value) => {
            if (!uniqueValues.has(value)) {
              uniqueValues.add(value);
              dropdownOptions.push({ value, label: value });
            } else {
              removedValues.push(value);
            }
          });
        }
      }

      setSurplusDropdown(dropdownOptions);
      // console.log("Removed Values:", removedValues);

      const dropdownNicknames = [];
      const uniqueNicknameValues = {};

      for (const [material, nicknamesObj] of Object.entries(
        response.data.nicknames
      )) {
        if (typeof nicknamesObj !== "object" || Array.isArray(nicknamesObj)) {
          continue;
        }

        for (const [key, value] of Object.entries(nicknamesObj)) {
          if (Array.isArray(value)) {
            if (!uniqueNicknameValues[key]) {
              uniqueNicknameValues[key] = [];
            }
            uniqueNicknameValues[key].push(...value);
          }
        }
      }

      for (const [label, values] of Object.entries(uniqueNicknameValues)) {
        dropdownNicknames.push({ label, value: [...new Set(values)] });
      }

      setSurplusNicknames(dropdownNicknames);
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getSurplusProductIngoingDropdown = ({
  surplusDropdown,
  setSurplusDropdown = function () {
    return;
  },
  setSurplusNicknames = function () {
    return;
  },
}) => {
  const urlParams = new URLSearchParams(window.location.search);
  const year = urlParams.get("year");
  const business = urlParams.get("business");
  const config = {
    method: "get",
    url: baseUrl + "/api/business/product-surplus-ingoing-dropdown",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    params: {
      year: year,
      business: business,
    },
  };

  axios(config)
    .then(function (response) {
      const dropdownOptions = [];
      const uniqueValues = new Set();
      const removedValues = [];

      for (const [key, values] of Object.entries(response.data.data)) {
        if (Array.isArray(values)) {
          values.forEach((value) => {
            if (!uniqueValues.has(value)) {
              uniqueValues.add(value);
              dropdownOptions.push({ value, label: value });
            } else {
              removedValues.push(value);
            }
          });
        }
      }

      setSurplusDropdown(dropdownOptions);
      // console.log("Removed Values:", removedValues);

      const dropdownNicknames = [];
      const uniqueNicknameValues = {};

      for (const [material, nicknamesObj] of Object.entries(
        response.data.nicknames
      )) {
        if (typeof nicknamesObj !== "object" || Array.isArray(nicknamesObj)) {
          continue;
        }

        for (const [key, value] of Object.entries(nicknamesObj)) {
          if (Array.isArray(value)) {
            if (!uniqueNicknameValues[key]) {
              uniqueNicknameValues[key] = [];
            }
            uniqueNicknameValues[key].push(...value);
          }
        }
      }

      for (const [label, values] of Object.entries(uniqueNicknameValues)) {
        dropdownNicknames.push({ label, value: [...new Set(values)] });
      }

      setSurplusNicknames(dropdownNicknames);
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getProductIngoingDropdown = ({
  inventoryDropdown,
  setNameDropdown = function () {
    return;
  },
  setInvoiceNumDropdown = function () {
    return;
  },
}) => {
  const urlParams = new URLSearchParams(window.location.search);
  const year = urlParams.get("year");
  const business = urlParams.get("business");
  const config = {
    method: "get",
    url: baseUrl + "/api/business/product-ingoing-dropdown",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    params: {
      year: year,
      business: business,
    },
  };

  axios(config)
    .then(function (response) {
      const dropdownOptions = [];
      const uniqueValues = new Set();
      const removedValues = [];

      for (const [key, values] of Object.entries(response.data.data)) {
        if (Array.isArray(values)) {
          values.forEach((value) => {
            if (!uniqueValues.has(value)) {
              uniqueValues.add(value);
              dropdownOptions.push({ value, label: value });
            } else {
              removedValues.push(value);
            }
          });
        }
      }

      setNameDropdown(dropdownOptions);
      // console.log("Removed Values:", removedValues);

      const dropdownInvNum = [];
      const uniqueInvNumValues = {};

      for (const [material, invNumsObj] of Object.entries(
        response.data.invoiceNum
      )) {
        if (typeof invNumsObj !== "object" || Array.isArray(invNumsObj)) {
          continue;
        }

        for (const [key, value] of Object.entries(invNumsObj)) {
          if (Array.isArray(value)) {
            if (!uniqueInvNumValues[key]) {
              uniqueInvNumValues[key] = [];
            }
            uniqueInvNumValues[key].push(...value);
          }
        }
      }

      for (const [label, values] of Object.entries(uniqueInvNumValues)) {
        dropdownInvNum.push({ label, value: [...new Set(values)] });
      }

      setInvoiceNumDropdown(dropdownInvNum);
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getProductOutgoingDropdown = ({
  inventoryDropdown,
  setNameDropdown = function () {
    return;
  },
  setInvoiceNumDropdown = function () {
    return;
  },
}) => {
  const urlParams = new URLSearchParams(window.location.search);
  const year = urlParams.get("year");
  const business = urlParams.get("business");
  const config = {
    method: "get",
    url: baseUrl + "/api/business/product-outgoing-dropdown",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    params: {
      year: year,
      business: business,
    },
  };

  axios(config)
    .then(function (response) {
      const dropdownOptions = [];
      const uniqueValues = new Set();
      const removedValues = [];

      for (const [key, values] of Object.entries(response.data.data)) {
        if (Array.isArray(values)) {
          values.forEach((value) => {
            if (!uniqueValues.has(value)) {
              uniqueValues.add(value);
              dropdownOptions.push({ value, label: value });
            } else {
              removedValues.push(value);
            }
          });
        }
      }

      setNameDropdown(dropdownOptions);
      // console.log("Removed Values:", removedValues);

      const dropdownInvNum = [];
      const uniqueInvNumValues = {};

      for (const [material, invNumsObj] of Object.entries(
        response.data.invoiceNum
      )) {
        if (typeof invNumsObj !== "object" || Array.isArray(invNumsObj)) {
          continue;
        }

        for (const [key, value] of Object.entries(invNumsObj)) {
          if (Array.isArray(value)) {
            if (!uniqueInvNumValues[key]) {
              uniqueInvNumValues[key] = [];
            }
            uniqueInvNumValues[key].push(...value);
          }
        }
      }

      for (const [label, values] of Object.entries(uniqueInvNumValues)) {
        dropdownInvNum.push({ label, value: [...new Set(values)] });
      }

      setInvoiceNumDropdown(dropdownInvNum);
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getProductTravelDropdown = ({
  inventoryDropdown,
  setNameDropdown = function () {
    return;
  },
  setInvoiceDate = function () {
    return;
  },
}) => {
  const urlParams = new URLSearchParams(window.location.search);
  const year = urlParams.get("year");
  const business = urlParams.get("business");
  const config = {
    method: "get",
    url: baseUrl + "/api/business/product-travel-dropdown",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    params: {
      year: year,
      business: business,
    },
  };

  axios(config)
    .then(function (response) {
      const dropdownOptions = [];
      const uniqueValues = new Set();
      const removedValues = [];

      for (const [key, values] of Object.entries(response.data.data)) {
        if (Array.isArray(values)) {
          values.forEach((value) => {
            if (!uniqueValues.has(value)) {
              uniqueValues.add(value);
              dropdownOptions.push({ value, label: value });
            } else {
              removedValues.push(value);
            }
          });
        }
      }

      setNameDropdown(dropdownOptions);
      // console.log("Removed Values:", removedValues);

      const dropdownDate = [];
      const uniqueDateValues = {};

      for (const [material, invNumsObj] of Object.entries(
        response.data.invoiceDate
      )) {
        if (typeof invNumsObj !== "object" || Array.isArray(invNumsObj)) {
          continue;
        }

        for (const [key, value] of Object.entries(invNumsObj)) {
          if (Array.isArray(value)) {
            if (!uniqueDateValues[key]) {
              uniqueDateValues[key] = [];
            }
            uniqueDateValues[key].push(...value);
          }
        }
      }

      for (const [label, values] of Object.entries(uniqueDateValues)) {
        dropdownDate.push({ label, value: [...new Set(values)] });
      }

      setInvoiceDate(dropdownDate);
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getUsePhaseDropdown = ({ dropdownData, setDropdownData }) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/use-phase-dropdown",
    headers: {},
  };

  axios(config)
    .then(function (response) {
      const getLanguage = () => i18n.language;
      const hiotName =
        getLanguage() === "en" ? "dropdown_name_en" : "dropdown_name";
      setDropdownData(
        response.data.data
          .map((material) => {
            material.value = material[hiotName];
            material.name = material[hiotName];

            return material;
          })
          .sort(compare)
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getGwpDropdown = ({ dropdownData, setDropdownData }) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/gwp-dropdown",
    headers: {},
  };

  axios(config)
    .then(function (response) {
      const getLanguage = () => i18n.language;
      const hiotName =
        getLanguage() === "en" ? "dropdown_name_en" : "dropdown_name";
      setDropdownData(
        response.data.data
          .map((material) => {
            material.value = material[hiotName];
            material.name = material[hiotName];

            return material;
          })
          .sort(compare)
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getIndirectEnergyDropdown = ({
  dropdownData,
  setDropdownData,
}) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/indirect-energy-dropdown",
    headers: {},
  };

  axios(config)
    .then(function (response) {
      const getLanguage = () => i18n.language;
      const hiotName =
        getLanguage() === "en" ? "dropdown_name_en" : "dropdown_name";
      setDropdownData(
        response.data.data
          .map((material) => {
            material.value = material[hiotName];
            material.name = material[hiotName];

            return material;
          })
          .sort(compare)
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getIndirectProcessDropdown = ({
  dropdownData,
  setDropdownData,
}) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/indirect-process-dropdown",
    headers: {},
  };

  axios(config)
    .then(function (response) {
      const getLanguage = () => i18n.language;
      const hiotName =
        getLanguage() === "en" ? "dropdown_name_en" : "dropdown_name";
      setDropdownData(
        response.data.data
          .map((material) => {
            material.value = material[hiotName];
            material.name = material[hiotName];

            return material;
          })
          .sort(compare)
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getIntermediateSourceDropdown = ({
  dropdownData,
  setDropdownData,
}) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/intermediate-source-used",
    headers: {},
  };

  axios(config)
    .then(function (response) {
      const getLanguage = () => i18n.language;
      const hiotName =
        getLanguage() === "en" ? "dropdown_name_en" : "dropdown_name";
      setDropdownData(
        response.data.data
          .map((material) => {
            material.value = material[hiotName];
            material.name = material[hiotName];

            return material;
          })
          .sort(compare)
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getProductFinalTreatmentDropdown = ({
  dropdownData,
  setDropdownData,
}) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/final-treatment-dropdown",
    headers: {},
  };

  axios(config)
    .then(function (response) {
      const getLanguage = () => i18n.language;
      const hiotName =
        getLanguage() === "en" ? "dropdown_name_en" : "dropdown_name";
      setDropdownData(
        response.data.data
          .map((material) => {
            material.value = material[hiotName];
            material.name = material[hiotName];

            return material;
          })
          .sort(compare)
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getPackagingMaterialList = ({
  dropdownData,
  setDropdownData,
  setTotalWeight,
  id,
}) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/" + id + "/packaging-material-list",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setDropdownData(
        response.data.data
          .map((material) => {
            return {
              value: material,
              name: material,
            };
          })
          .sort(compare)
      );
      setTotalWeight(response.data.total_weight);
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getDisassemblyComponentList = ({
  dropdownData,
  setDropdownData,
  setWeight,
  setList,
  id,
}) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/" + id + "/disassembly-component-list",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setDropdownData(
        response.data.data
          .map((material) => {
            return {
              value: material,
              name: material,
            };
          })
          .sort(compare)
      );
      setWeight(response.data.total_weight);
      setList(response.data.total_list);
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getInventoryIngoingPackagingDropdown = ({
  inventoryDropdown,
  businessId,
  setInventoryDropdown = function () {
    return;
  },
  setInventoryNicknames = function () {
    return;
  },
  setInventoryQty = function () {
    return;
  },
}) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/inventory-ingoing-packaging-dropdown",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    params: {
      business: businessId,
    },
  };

  axios(config)
    .then(function (response) {
      const dropdownOptions = [];
      const uniqueValues = new Set();
      const removedValues = [];

      for (const [key, values] of Object.entries(response.data.data)) {
        if (Array.isArray(values)) {
          values.forEach((value) => {
            if (!uniqueValues.has(value)) {
              uniqueValues.add(value);
              dropdownOptions.push({ value, label: value });
            } else {
              removedValues.push(value);
            }
          });
        }
      }

      setInventoryDropdown(dropdownOptions);

      const dropdownNicknames = [];
      const uniqueNicknameValues = {};

      for (const [material, nicknamesObj] of Object.entries(
        response.data.nicknames
      )) {
        if (typeof nicknamesObj !== "object" || Array.isArray(nicknamesObj)) {
          continue;
        }

        for (const [key, value] of Object.entries(nicknamesObj)) {
          if (Array.isArray(value)) {
            if (!uniqueNicknameValues[key]) {
              uniqueNicknameValues[key] = [];
            }
            uniqueNicknameValues[key].push(...value);
          }
        }
      }

      for (const [label, values] of Object.entries(uniqueNicknameValues)) {
        dropdownNicknames.push({ label, value: [...new Set(values)] });
      }

      setInventoryNicknames(dropdownNicknames);

      const dropdownQty = [];
      const uniqueQtyValues = {};

      for (const [material, qtyObj] of Object.entries(response.data.qty)) {
        if (typeof qtyObj !== "object" || Array.isArray(qtyObj)) {
          continue;
        }

        for (const [key, value] of Object.entries(qtyObj)) {
          if (Array.isArray(value)) {
            if (!uniqueQtyValues[key]) {
              uniqueQtyValues[key] = [];
            }
            uniqueQtyValues[key].push(...value);
          }
        }
      }

      for (const [label, values] of Object.entries(uniqueQtyValues)) {
        const labelValues = label.split(" & ");
        const labelMaterial = labelValues[0];
        const labelNickname = labelValues[1];
        const [value] = values;
        dropdownQty.push({ labelMaterial, labelNickname, values: value });
      }
      setInventoryQty(dropdownQty);
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getProductIntermediateSoldSourcesDropdown = ({
  setDropdownData,
}) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/intermediate-sold-sources-dropdown",
    headers: {},
  };

  axios(config)
    .then(function (response) {
      const getLanguage = () => i18n.language;
      const hiotName =
        getLanguage() === "en" ? "dropdown_name_en" : "dropdown_name";
      setDropdownData(
        response.data.data
          .map((material) => {
            material.value = material[hiotName];
            material.name = material[hiotName];

            return material;
          })
          .sort(compare)
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getProductIndirectEmitCo2Dropdown = ({ setDropdownData }) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/indirect-emit-co2-dropdown",
    headers: {},
  };

  axios(config)
    .then(function (response) {
      const getLanguage = () => i18n.language;
      const hiotName =
        getLanguage() === "en" ? "dropdown_name_en" : "dropdown_name";
      setDropdownData(
        response.data.data
          .map((material) => {
            material.value = material[hiotName];
            material.name = material[hiotName];

            return material;
          })
          .sort(compare)
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getFuelVehicleDropdown = ({
  setDropdownData = function () {
    return;
  },
}) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/fuel-electric-vehicle-dropdown",
    headers: {},
  };

  axios(config)
    .then(function (response) {
      const getLanguage = () => i18n.language;
      const hiotName =
        getLanguage() === "en" ? "dropdown_name_en" : "dropdown_name";
      setDropdownData(
        response.data.data
          .map((material) => {
            material.value = material[hiotName];
            material.name = material[hiotName];

            return material;
          })
          .sort(compare)
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getRegisteredVehicleTypesDropdown = ({
  businessId,
  setDropdownData = function () {
    return;
  },
}) => {
  // Fetch data from both FuelVehicle and NonFuelVehicle APIs
  const fuelVehicleConfig = {
    method: "get",
    url: baseUrl + "/api/business/" + businessId + "/fuel-reg-vehicle",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  const nonFuelVehicleConfig = {
    method: "get",
    url: baseUrl + "/api/business/" + businessId + "/reg-vehicle",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  // Use Promise.all to fetch both APIs simultaneously
  Promise.all([axios(fuelVehicleConfig), axios(nonFuelVehicleConfig)])
    .then(function ([fuelResponse, nonFuelResponse]) {
      const vehicleTypes = new Set(); // Use Set to ensure uniqueness
      const dropdownItems = [];

      // Process FuelVehicle data - extract fuel_type
      if (fuelResponse.data.data && Array.isArray(fuelResponse.data.data)) {
        fuelResponse.data.data.forEach((vehicle) => {
          if (
            vehicle.fuel_type &&
            typeof vehicle.fuel_type === "object" &&
            vehicle.fuel_type.value
          ) {
            const fuelType = vehicle.fuel_type.value;
            if (!vehicleTypes.has(fuelType)) {
              vehicleTypes.add(fuelType);
              dropdownItems.push({
                id: `fuel_${fuelType}`,
                name: fuelType,
                value: fuelType,
                source: "fuel_vehicle",
              });
            }
          } else if (
            vehicle.fuel_type &&
            typeof vehicle.fuel_type === "string"
          ) {
            const fuelType = vehicle.fuel_type;
            if (!vehicleTypes.has(fuelType)) {
              vehicleTypes.add(fuelType);
              dropdownItems.push({
                id: `fuel_${fuelType}`,
                name: fuelType,
                value: fuelType,
                source: "fuel_vehicle",
              });
            }
          }
        });
      }

      // Process NonFuelVehicle data - extract vehicle_type
      if (
        nonFuelResponse.data.data &&
        Array.isArray(nonFuelResponse.data.data)
      ) {
        nonFuelResponse.data.data.forEach((vehicle) => {
          if (
            vehicle.vehicle_type &&
            typeof vehicle.vehicle_type === "object" &&
            vehicle.vehicle_type.value
          ) {
            const vehicleType = vehicle.vehicle_type.value;
            if (!vehicleTypes.has(vehicleType)) {
              vehicleTypes.add(vehicleType);
              dropdownItems.push({
                id: `nonfuel_${vehicleType}`,
                name: vehicleType,
                value: vehicleType,
                source: "non_fuel_vehicle",
              });
            }
          } else if (
            vehicle.vehicle_type &&
            typeof vehicle.vehicle_type === "string"
          ) {
            const vehicleType = vehicle.vehicle_type;
            if (!vehicleTypes.has(vehicleType)) {
              vehicleTypes.add(vehicleType);
              dropdownItems.push({
                id: `nonfuel_${vehicleType}`,
                name: vehicleType,
                value: vehicleType,
                source: "non_fuel_vehicle",
              });
            }
          }
        });
      }

      // Sort the dropdown items alphabetically
      dropdownItems.sort((a, b) => a.name.localeCompare(b.name));

      setDropdownData(dropdownItems);
    })
    .catch(function (error) {
      console.log("Error fetching registered vehicle types:", error);
      // Fallback to empty array if API fails
      setDropdownData([]);
    });
};

export const getHotelLocationDropdown = ({ setDropdown }) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/hotel-location-dropdown",
    headers: {},
  };

  const getLanguage = () => i18n.language;
  const hiotName =
    getLanguage() === "en" ? "dropdown_name_en" : "dropdown_name";
  axios(config)
    .then(function (response) {
      // console.log(response.data.data);
      setDropdown(
        response.data.data
          .map((item) => {
            return {
              ...item,
              value: item[hiotName],
              name: item[hiotName],
              id: item.id,
            };
          })
          .sort(compare)
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getProcessingIntermediateDropdown = ({
  setDropdown = function () {
    return;
  },
}) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/process-intermediate-dropdown",
    headers: {},
  };

  axios(config)
    .then(function (response) {
      // console.log(response.data.data);
      const getLanguage = () => i18n.language;
      const hiotName = getLanguage() === "en" ? "dropdown_en" : "dropdown";
      setDropdown(
        response.data.data
          .map((size) => {
            size.value = size[hiotName];
            size.name = size[hiotName];

            return size;
          })
          .sort(compare)
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getProcessingFinalTreatmentDropdown = ({
  setDropdown = function () {
    return;
  },
}) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/processing-final-treatment",
    headers: {},
  };

  axios(config)
    .then(function (response) {
      // console.log(response.data.data);
      const getLanguage = () => i18n.language;
      const hiotName = getLanguage() === "en" ? "dropdown_en" : "dropdown";
      setDropdown(
        response.data.data
          .map((size) => {
            size.value = size[hiotName];
            size.name = size[hiotName];

            return size;
          })
          .sort(compare)
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getCompDirectEnergyDropdown = ({
  setDropdown = function () {
    return;
  },
}) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/comp-direct-energy-dropdown",
    headers: {},
  };

  axios(config)
    .then(function (response) {
      const getLanguage = () => i18n.language;
      const hiotName = getLanguage() === "en" ? "dropdown_en" : "dropdown";
      setDropdown(
        response.data.data
          .map((size) => {
            size.value = size[hiotName];
            size.name = size[hiotName];

            return size;
          })
          .sort(compare)
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getCompUseGwpDropdown = ({
  setDropdown = function () {
    return;
  },
}) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/comp-use-gwp-dropdown",
    headers: {},
  };

  axios(config)
    .then(function (response) {
      const getLanguage = () => i18n.language;
      const hiotName = getLanguage() === "en" ? "dropdown_en" : "dropdown";
      setDropdown(
        response.data.data
          .map((size) => {
            size.value = size[hiotName];
            size.name = size[hiotName];

            return size;
          })
          .sort(compare)
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getCompIndirectEmitDropdown = ({
  setDropdown = function () {
    return;
  },
}) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/comp-indirect-emit-dropdown",
    headers: {},
  };

  axios(config)
    .then(function (response) {
      const getLanguage = () => i18n.language;
      const hiotName = getLanguage() === "en" ? "dropdown_en" : "dropdown";
      setDropdown(
        response.data.data
          .map((size) => {
            size.value = size[hiotName];
            size.name = size[hiotName];

            return size;
          })
          .sort(compare)
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getCompIndirectEnergyDropdown = ({
  setDropdown = function () {
    return;
  },
}) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/comp-indirect-energy-dropdown",
    headers: {},
  };

  axios(config)
    .then(function (response) {
      const getLanguage = () => i18n.language;
      const hiotName = getLanguage() === "en" ? "dropdown_en" : "dropdown";
      setDropdown(
        response.data.data
          .map((size) => {
            size.value = size[hiotName];
            size.name = size[hiotName];

            return size;
          })
          .sort(compare)
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getCompIntermediateEnergyDropdown = ({
  setDropdown = function () {
    return;
  },
}) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/comp-intermediate-energy-dropdown",
    headers: {},
  };

  axios(config)
    .then(function (response) {
      const getLanguage = () => i18n.language;
      const hiotName = getLanguage() === "en" ? "dropdown_en" : "dropdown";
      setDropdown(
        response.data.data
          .map((size) => {
            size.value = size[hiotName];
            size.name = size[hiotName];

            return size;
          })
          .sort(compare)
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getCompFinalTreatmentDropdown = ({
  setDropdown = function () {
    return;
  },
}) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/comp-final-treatment-dropdown",
    headers: {},
  };

  axios(config)
    .then(function (response) {
      const getLanguage = () => i18n.language;
      const hiotName = getLanguage() === "en" ? "dropdown_en" : "dropdown";
      setDropdown(
        response.data.data
          .map((size) => {
            size.value = size[hiotName];
            size.name = size[hiotName];

            return size;
          })
          .sort(compare)
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getProdIndirectEmitDropdown = ({
  setDropdown = function () {
    return;
  },
}) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/prod-indirect-emit-dropdown",
    headers: {},
  };

  axios(config)
    .then(function (response) {
      const getLanguage = () => i18n.language;
      const hiotName = getLanguage() === "en" ? "dropdown_en" : "dropdown";
      const customCompare = (a, b) => {
        // If both are "Process missing" or neither is, use normal comparison
        if (
          (a[hiotName] === "Process missing") ===
          (b[hiotName] === "Process missing")
        ) {
          return compare(a, b);
        }
        // If only one is "Process missing", we can reliably put it first
        return a[hiotName] === "Process missing" ? -1 : 1;
      };
      const data = response.data.data;
      setDropdown(
        [
          {
            dropdown: "Process missing",
            dropdown_en: "Process missing",
            unit: "N/A",
          },
          ...data,
        ]
          .map((size) => {
            size.value = size[hiotName];
            size.name = size[hiotName];

            return size;
          })
          .sort(customCompare)
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getProdComponentDropdown = ({
  setDropdown = function () {
    return;
  },
}) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/prod-component-dropdown",
    headers: {},
  };

  axios(config)
    .then(function (response) {
      const getLanguage = () => i18n.language;
      const hiotName = getLanguage() === "en" ? "dropdown_en" : "dropdown";
      setDropdown(
        response.data.data
          .map((size) => {
            size.value = size[hiotName];
            size.name = size[hiotName];

            return size;
          })
          .sort(compare)
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getProdManufacturingProcessDropdown = ({
  setDropdown = function () {
    return;
  },
}) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/prod-manufacturing-process-dropdown",
    headers: {},
  };

  axios(config)
    .then(function (response) {
      const getLanguage = () => i18n.language;
      const hiotName = getLanguage() === "en" ? "dropdown_en" : "dropdown";
      setDropdown(
        response.data.data
          .map((size) => {
            size.value = size[hiotName];
            size.name = size[hiotName];

            return size;
          })
          .sort(compare)
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getProdManufacturingMaterialDropdown = ({
  setDropdown = function () {
    return;
  },
}) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/prod-manufacturing-material-dropdown",
    headers: {},
  };

  axios(config)
    .then(function (response) {
      const getLanguage = () => i18n.language;
      const hiotName = getLanguage() === "en" ? "dropdown_en" : "dropdown";
      setDropdown(
        response.data.data
          .map((size) => {
            size.value = size[hiotName];
            size.name = size[hiotName];

            return size;
          })
          .sort(compare)
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getProdManufacturingWaterDropdown = ({
  setDropdown = function () {
    return;
  },
}) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/prod-manufacturing-water-dropdown",
    headers: {},
  };

  axios(config)
    .then(function (response) {
      const getLanguage = () => i18n.language;
      const hiotName = getLanguage() === "en" ? "dropdown_en" : "dropdown";
      setDropdown(
        response.data.data
          .map((size) => {
            size.value = size[hiotName];
            size.name = size[hiotName];

            return size;
          })
          .sort(compare)
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getProdProductionMachineVehicleDropdown = ({
  setDropdown = function () {
    return;
  },
}) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/prod-production-machine-dropdown",
    headers: {},
  };

  axios(config)
    .then(function (response) {
      const getLanguage = () => i18n.language;
      const hiotName = getLanguage() === "en" ? "dropdown_en" : "dropdown";
      setDropdown(
        response.data.data
          .map((size) => {
            size.value = size[hiotName];
            size.name = size[hiotName];

            return size;
          })
          .sort(compare)
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getProdSurplusResourcesDropdown = ({
  setDropdown = function () {
    return;
  },
}) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/prod-surplus-resources-dropdown",
    headers: {},
  };

  axios(config)
    .then(function (response) {
      const getLanguage = () => i18n.language;
      const hiotName = getLanguage() === "en" ? "dropdown_en" : "dropdown";
      setDropdown(
        response.data.data
          .map((size) => {
            size.value = size[hiotName];
            size.name = size[hiotName];

            return size;
          })
          .sort(compare)
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getGlobalIdematPurchaseEnergy = ({
  setDropdown = function () {
    return;
  },
}) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/global-purchased-energy-idemat",
    headers: {},
  };

  axios(config)
    .then(function (response) {
      const getLanguage = () => i18n.language;
      const hiotName = getLanguage() === "en" ? "dropdown_en" : "dropdown";
      setDropdown(
        response.data.data
          .map((size) => {
            size.value = size[hiotName];
            size.name = size[hiotName];

            return size;
          })
          .sort(compare)
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getGlobalIdematHomeEnergy = ({
  setDropdown = function () {
    return;
  },
}) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/global-home-energy-idemat",
    headers: {},
  };

  axios(config)
    .then(function (response) {
      const getLanguage = () => i18n.language;
      const hiotName = getLanguage() === "en" ? "dropdown_en" : "dropdown";
      setDropdown(
        response.data.data
          .map((size) => {
            size.value = size[hiotName];
            size.name = size[hiotName];

            return size;
          })
          .sort(compare)
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getGlobalIdematSymbioticEnergy = ({
  setDropdown = function () {
    return;
  },
}) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/global-symbiotic-energy-idemat",
    headers: {},
  };

  axios(config)
    .then(function (response) {
      const getLanguage = () => i18n.language;
      const hiotName = getLanguage() === "en" ? "dropdown_en" : "dropdown";
      setDropdown(
        response.data.data
          .map((size) => {
            size.value = size[hiotName];
            size.name = size[hiotName];

            return size;
          })
          .sort(compare)
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getGlobalIdematInventoryChemical = ({
  setDropdown = function () {
    return;
  },
}) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/global-inventory-chemical-idemat",
    headers: {},
  };

  axios(config)
    .then(function (response) {
      const getLanguage = () => i18n.language;
      const hiotName = getLanguage() === "en" ? "dropdown_en" : "dropdown";
      setDropdown(
        response.data.data
          .map((size) => {
            size.value = size[hiotName];
            size.name = size[hiotName];

            return size;
          })
          .sort(compare)
      );
    })
    .catch(function (error) {
      console.log(error);
    });
};
